import { Component, input } from '@angular/core';

/**
 * The "now" hairline drawn across today's column. The clock time itself lives
 * once in the hour gutter rather than on every column, so this only marks the
 * position.
 */
@Component({
  selector: 'app-calendar-time-step',
  imports: [],
  templateUrl: './calendar-time-step.component.html'
})
export class CalendarTimeStepComponent {
  isToday = input.required<boolean>();
  nowTimeStepPosition = input<string | null>(null);
}
